// extracted by mini-css-extract-plugin
module.exports = {"sidebar-navigation":"sidebar-navigation_sidebar-navigation__3WZ6i"};